import { GoogleAuthProvider } from '@sendible/frontendv2/src/utils/googleAuthentication/GoogleAuthContext';
import { ComposeBoxProvider } from './composeBoxContext';
import { MediaSystemComponents } from './MediaSystemComponents';

export const MediaSystem = () => {
  return (
    <ComposeBoxProvider>
      <GoogleAuthProvider>
        <MediaSystemComponents />
      </GoogleAuthProvider>
    </ComposeBoxProvider>
  );
};
